import React from 'react';
import PropTypes from 'prop-types';

export default function SubmitButton({
  type = 'submit',
  label,
  onClick,
  disabled = false,
  primary = false,        // legacy path
  variant,                // 'primary' | 'secondary' | 'ghost' (new path)
  size,                   // 'sm' | 'xs'
  cssVars,                // optional per-button CSS variable overrides
}) {
  // Build className (legacy by default)
  const className = variant
    ? ['btn', `btn--${variant}`, size ? `btn--${size}` : ''].join(' ').trim()
    : (primary ? 'button button-primary' : 'button button-secondary');

  // Inline CSS variable overrides (scoped to this button only)
  // Pass actual colour strings like '#123456' or 'rgba(...)'
  // Example usage: cssVars={{ primary: teamPrimary, secondary: teamSecondary, heading: '#fff' }}
  const style = cssVars ? {
    ...(cssVars.primary   && { "--team-primary": cssVars.primary }),
    ...(cssVars.secondary && { "--team-secondary": cssVars.secondary }),
    ...(cssVars.heading   && { "--team-heading-text": cssVars.heading }),
    ...(cssVars.body      && { "--team-body-text": cssVars.body }),
  } : undefined;
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={style}
    >
      {label}
    </button>
  );
}

SubmitButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit']),
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  primary: PropTypes.bool, // legacy
  variant: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'danger']),
  size: PropTypes.oneOf(['sm', 'xs']),
  cssVars: PropTypes.shape({
    primary: PropTypes.string,   // sets --team-primary
    secondary: PropTypes.string, // sets --team-secondary
    heading: PropTypes.string,   // sets --team-heading-text
    body: PropTypes.string,      // sets --team-body-text
  }),
};
